import PropTypes from 'prop-types';
import React from 'react';
export default class StateNavigationLinkColumn extends React.PureComponent {
    render() {
        const stateNavigationLinks = this.props.stateNames.map((stateDisplayName) =>
            <li key={stateDisplayName}><a href={'#' + stateDisplayName}>{stateDisplayName}</a></li>,
        );
        return (
            <div className='col col3'>
                <ul>
                    {stateNavigationLinks}
                </ul>
            </div>
        );
    }
}

StateNavigationLinkColumn.propTypes = {
    stateNames: PropTypes.arrayOf(PropTypes.string).isRequired
};
